import { render } from "./RolesVersionView.vue?vue&type=template&id=c9f40b40&scoped=true"
import script from "./RolesVersionView.vue?vue&type=script&lang=js"
export * from "./RolesVersionView.vue?vue&type=script&lang=js"

import "./RolesVersionView.vue?vue&type=style&index=0&id=c9f40b40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f40b40"]])

export default __exports__